import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class CookiesService {
  constructor(
    private readonly cookieService: CookieService,
    @Inject(DOCUMENT) private readonly document: Document
  ) {}

  set(
    key: string,
    value: string,
    ttlSeconds?: number,
    sameSite: 'Lax' | 'Strict' | 'None' = 'Lax'
  ): void {
    const secure = this.document.defaultView?.location.protocol === 'https:';
    // ngx-cookie-service expresa la expiración en días (o como Date). Convertimos
    // los segundos recibidos a días para conservar la API previa basada en TTL.
    const expires =
      ttlSeconds && Number.isFinite(ttlSeconds)
        ? Math.max(0, ttlSeconds) / 86400
        : undefined;

    this.cookieService.set(key, value, {
      path: '/',
      // SameSite=None exige Secure; en otros casos se respeta el protocolo actual.
      sameSite,
      secure: sameSite === 'None' ? true : secure,
      ...(expires !== undefined ? { expires } : {})
    });
  }

  get(key: string): string | null {
    if (!this.cookieService.check(key)) {
      return null;
    }
    const value = this.cookieService.get(key);
    return value ? value : null;
  }

  delete(key: string): void {
    this.cookieService.delete(key, '/');
  }
}
